import { computed, toValue, defineComponent, useAttrs, createBlock, openBlock, resolveDynamicComponent, unref, mergeProps, withCtx, createElementBlock, createCommentVNode, toDisplayString, normalizeClass, createElementVNode, Fragment, renderList, createVNode } from "vue";
import { _sfc_main as _sfc_main$2 } from "../../WBadge/WBadge/index.js";
import { useRouter } from "vue-router";
import { _export_sfc } from "../../WAccordion/index.js";
import "../../WIcon/WIconStd/index.js";
import "../../WIcon/WIconExt/index.js";
import './index.css';const BREADCRUMB_SIZES = ["xs", "sm"];
const BREADCRUMB_DEFAULT_SIZE$1 = BREADCRUMB_SIZES[1];
const DATA_TEST$1 = {
  ELM: "w-breadcrumb-item",
  ICON: "w-breadcrumb-item-icon",
  LABEL: "w-breadcrumb-item-label",
  SEPARATOR: "w-breadcrumb-item-separator"
};
const BREADCRUMB_DEFAULT_SIZE = BREADCRUMB_DEFAULT_SIZE$1;
const DATA_TEST = {
  ELM: "w-breadcrumbs",
  LIST: "w-breadcrumbs-list",
  ITEM: "w-breadcrumbs-item",
  SEPARATOR: "w-breadcrumbs-separator"
};
function useSmartLink(props) {
  const router = useRouter();
  const isDisabled = computed(() => toValue(props).disabled || void 0);
  const to = computed(() => toValue(props).to);
  const isLink = computed(() => !!to.value);
  const isSpan = computed(() => isLink.value && isDisabled.value);
  const navigate = () => {
    if (to.value && !isDisabled.value) {
      router.push(to.value);
    }
  };
  const href = computed(() => {
    if (to.value) {
      return router.resolve(to.value).href;
    }
    return "";
  });
  const ariaDisabled = computed(
    () => isDisabled.value ? "true" : "false"
  );
  const response = computed(() => {
    if (isSpan.value) {
      const response3 = {
        tag: "span",
        attrs: {}
      };
      return response3;
    }
    if (isLink.value) {
      const response3 = {
        tag: "a",
        attrs: {
          href: href.value,
          onClick(e) {
            var _a, _b;
            e.preventDefault();
            (_b = (_a = toValue(props)).onClick) == null ? void 0 : _b.call(_a, e);
            navigate();
          }
        }
      };
      return response3;
    }
    const response2 = {
      tag: "button",
      attrs: {
        "aria-disabled": ariaDisabled.value,
        disabled: isDisabled.value,
        onClick(e) {
          var _a, _b;
          (_b = (_a = toValue(props)).onClick) == null ? void 0 : _b.call(_a, e);
        }
      }
    };
    return response2;
  });
  return {
    smartLink: response
  };
}
const _hoisted_1$1 = ["data-t"];
const _hoisted_2$1 = ["data-t"];
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "WBreadcrumbsItem",
  props: {
    icon: { default: void 0 },
    label: { default: void 0 },
    disabled: { type: Boolean },
    selected: { type: Boolean },
    to: { default: void 0 },
    size: {}
  },
  setup(__props) {
    const attrs = useAttrs();
    const props = __props;
    const { smartLink } = useSmartLink(() => ({
      to: props.to,
      disabled: props.disabled
    }));
    const classes = computed(() => [
      `--size-${props.size}`,
      {
        "--selected": props.selected,
        "--disabled": props.disabled
      }
    ]);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(unref(smartLink).tag), mergeProps({
        class: ["w-breadcrumbs-item", classes.value],
        "data-t": unref(DATA_TEST$1).ELM
      }, { ...unref(smartLink).attrs, ...unref(attrs) }), {
        default: withCtx(() => [
          _ctx.icon ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "w-breadcrumbs-item__icon-wrap",
            "data-t": unref(DATA_TEST$1).ICON
          }, [
            _ctx.icon ? (openBlock(), createBlock(_sfc_main$2, {
              key: 0,
              class: "w-breadcrumbs-item__icon",
              name: _ctx.icon
            }, null, 8, ["name"])) : createCommentVNode("", true)
          ], 8, _hoisted_1$1)) : createCommentVNode("", true),
          _ctx.label ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: "w-breadcrumbs-item__label",
            "data-t": unref(DATA_TEST$1).LABEL
          }, toDisplayString(_ctx.label), 9, _hoisted_2$1)) : createCommentVNode("", true)
        ]),
        _: 1
      }, 16, ["class", "data-t"]);
    };
  }
});
const WBreadcrumbsItem = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["__scopeId", "data-v-5fca9481"]]);
const _hoisted_1 = ["data-t"];
const _hoisted_2 = ["data-t"];
const _hoisted_3 = ["data-t"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WBreadcrumbs",
  props: {
    items: { default: void 0 },
    separator: { default: void 0 },
    size: { default: BREADCRUMB_DEFAULT_SIZE }
  },
  setup(__props) {
    const props = __props;
    const classes = computed(() => [
      {
        [`--size-${props.size}`]: props.size
      }
    ]);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("nav", {
        "aria-label": "Breadcrumb",
        class: normalizeClass(["w-breadcrumbs", classes.value]),
        "data-t": unref(DATA_TEST).ELM
      }, [
        createElementVNode("ol", {
          class: "w-breadcrumbs__list",
          "data-t": unref(DATA_TEST).LIST
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item, index) => {
            return openBlock(), createElementBlock("li", {
              key: index,
              class: "w-breadcrumbs__list-item",
              "data-t": unref(DATA_TEST).ITEM
            }, [
              createVNode(WBreadcrumbsItem, mergeProps({
                class: "w-breadcrumbs__breadcrumb-item",
                size: _ctx.size
              }, { ref_for: true }, item, {
                selected: item.selected
              }), null, 16, ["size", "selected"]),
              createVNode(_sfc_main$2, {
                name: "outline-chevron-right-small",
                class: "w-breadcrumbs__icon-separator",
                "data-t": unref(DATA_TEST).SEPARATOR
              }, null, 8, ["data-t"])
            ], 8, _hoisted_3);
          }), 128))
        ], 8, _hoisted_2)
      ], 10, _hoisted_1);
    };
  }
});
const WBreadcrumbs = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-fa780b47"]]);
export {
  WBreadcrumbs,
  WBreadcrumbsItem,
  useSmartLink
};
